// extracted by mini-css-extract-plugin
export default {"wrapper":"dTw3POga7lp1z7qMJg6R"};